const eagerZhTW = import.meta.glob<{ default: Record<string, unknown> }>('./zh-TW/*.ts', { eager: true });

const messages: Record<string, Record<string, unknown>> = {};

const buildResources = (mods: Record<string, { default?: Record<string, unknown> }>): Record<string, unknown> => {
  const res: Record<string, unknown> = {};
  Object.keys(mods).forEach((path) => {
    const match = path.match(/\.\/[^/]+\/([^/]+)\.ts$/);
    if (!match) return;
    const namespace = match[1];
    const module = mods[path];
    if (!module?.default) return;
    if (namespace === 'translation') {
      res.home = { ...((res.home as Record<string, unknown>) ?? {}), ...module.default };
    } else {
      res[namespace] = module.default;
    }
  });
  return res;
};

messages['zh-TW'] = buildResources(eagerZhTW);

const lazyLangs = import.meta.glob<{ default: Record<string, unknown> }>([
  './zh-CN/*.ts',
  './en/*.ts',
  './ja/*.ts',
  './ko/*.ts',
]);

let loadPromise: Promise<void> | null = null;

export async function loadLanguage(lang: string): Promise<void> {
  if (lang === 'zh-TW' || messages[lang]) return;
  const paths = Object.keys(lazyLangs).filter((p) => p.startsWith(`./${lang}/`));
  if (paths.length === 0) return;
  const mods: Record<string, { default?: Record<string, unknown> }> = {};
  for (const p of paths) {
    mods[p] = await lazyLangs[p]();
  }
  messages[lang] = buildResources(mods);
  const { default: i18n } = await import('i18next');
  Object.entries(messages[lang]).forEach(([ns, res]) => {
    i18n.addResourceBundle(lang, ns, res as Record<string, unknown>, true, true);
  });
}

export function loadLanguageCached(lang: string): Promise<void> {
  if (loadPromise) return loadPromise;
  loadPromise = loadLanguage(lang).finally(() => { loadPromise = null; });
  return loadPromise;
}

export default messages;
